<template>
  <div class="product-items-slider-fi">
    <product-teasers-fi
      :custom-fields="customFields"
      :light="isLight"
      :white
      :expandable
      is-guided-recommandation
    />
  </div>
</template>

<script>
import ProductTeasersFi from '@/pages/product-teasers-fi/ProductTeasersFi.vue';

export default {
  name: 'ProductItemsSliderFi',
  components: {
    ProductTeasersFi,
  },
  props: {
    productItems: {
      type: Array,
      default: () => [],
    },
    sliderHeadline: {
      type: String,
      default: '',
    },
    isFamily: {
      type: Boolean,
      default: false,
    },
    isLight: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
    },
    white: {
      type: Boolean,
    },
  },
  computed: {
    customFields() {
      const fields = {
        headline: { value: this.sliderHeadline },
        hideContent: { value: true },
      };

      if (this.isFamily) {
        fields.familyList = this.productListValue;
      } else {
        fields.productList = this.productListValue;
      }

      return fields;
    },
    productListValue() {
      return { value: this.productItems?.map(({ ProductId }) => ProductId).join('|') };
    },
  },
};
</script>

<style scoped src="./product-items-slider-fi" />
